export default "__VITE_ASSET__98cX6lfJ__"